import {loadScript} from 'methods/utils';
import HotelMap from 'hotels/src/js/components/hotel-map';

/**
 * VK плагин
 */
loadScript('//vk.com/js/api/openapi.js?120').then(() => {
    const $widget = document.querySelector('#vk_widget');

    if ($widget) {
        const vk_group_id = $widget.dataset.vkGroupId;

        if (vk_group_id) {

            /**
             * Подключаем VK плагин
             */
            function VK_Widget_Init(){
                const getWidth = document.getElementById('vk_widget').clientWidth;

                document.getElementById('vk_widget').innerHTML = '<div id="vk_groups"></div>';

                VK.Widgets.Group('vk_groups', {
                    mode: 3,
                    color2: '37474F',
                    width: getWidth,
                    no_cover: 1,
                }, vk_group_id);
            }

            VK_Widget_Init();

            document.addEventListener('resize', VK_Widget_Init);
        }
    }
});

// Блок карты
const map = new HotelMap();
const mapClosestHotels = document.querySelector('.js-mapClosestHotels');

if (mapClosestHotels) {
    mapClosestHotels.addEventListener('change', () => {
        map.setHotelsVisible(mapClosestHotels.checked);
    });

    map.whenInitialized(() => {
        map.setHotelsVisible(mapClosestHotels.checked);
    });
}
